export default __webpack_public_path__ + "static/media/rtl_testimonials_background.0bdd0fe1.png";